import { __assign, __awaiter, __generator } from "tslib";
import { AuthType, } from '@office-start/auth-types';
import { resolveConfig, } from '@office-start/config-resolver-service';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { logError } from '@office-start/telemetry-service';
import { applyParamFromWindow } from '@office-start/window-utility';
import { requestWithOfficeContext } from '@office-start/xhr-service';
// TODO: Remove access to this function and have identity accessible only via fetchIdentity and useIdentity. Can then remove singleton
var identityNetworkPromise;
var identityKey = 'identity';
/**
 * How stand alone version of app gets identity.
 * Angular app does not use this, passes identity info down as props instead.
 */
export function getIdentity(correlationId, officeHomeApiRoot) {
    return __awaiter(this, void 0, void 0, function () {
        var bridgeIdentity, identity, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, getIdentityFromClient()];
                case 1:
                    bridgeIdentity = _a.sent();
                    if (!bridgeIdentity && !identityNetworkPromise) {
                        identityNetworkPromise = getIdentityFromNetwork(correlationId, officeHomeApiRoot);
                    }
                    if (!!bridgeIdentity) return [3 /*break*/, 3];
                    return [4 /*yield*/, identityNetworkPromise];
                case 2:
                    bridgeIdentity = _a.sent();
                    _a.label = 3;
                case 3:
                    if (!bridgeIdentity ||
                        !bridgeIdentity.puid ||
                        !bridgeIdentity.tenantId) {
                        throw new Error('Invalid identity');
                    }
                    identity = __assign(__assign({}, bridgeIdentity), { isMsa: bridgeIdentity.authType === AuthType.MSA, isOrgId: bridgeIdentity.authType === AuthType.OrgId });
                    return [2 /*return*/, identity];
                case 4:
                    err_1 = _a.sent();
                    logError({
                        eventName: 'GetIdentity_Error',
                        message: "Failed to get identity: ".concat(err_1),
                    });
                    identityNetworkPromise = undefined;
                    return [2 /*return*/, Promise.reject(err_1)];
                case 5: return [2 /*return*/];
            }
        });
    });
}
function getIdentityFromClient() {
    return __awaiter(this, void 0, void 0, function () {
        var options, config;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options = {
                        disableLegacyNetworkConfigs: true,
                    };
                    return [4 /*yield*/, resolveConfig(identityKey, options)];
                case 1:
                    config = _a.sent();
                    return [2 /*return*/, config];
            }
        });
    });
}
function getIdentityFromNetwork(correlationId, officeHomeApiRoot) {
    var url = new URL("".concat(officeHomeApiRoot, "/api/identity"), window.location.origin);
    applyParamFromWindow(url, "auth" /* OfficeQueryParam.Auth */);
    applyParamFromWindow(url, "mockauth" /* OfficeQueryParam.MockAuth */);
    applyParamFromWindow(url, "flight" /* OfficeQueryParam.Flight */);
    var requestConfig = {
        url: url.toString(),
        method: "GET" /* HttpRequestMethod.Get */,
    };
    return requestWithOfficeContext(KnownInstrumentationEvents.IdentityRequest, "Identity" /* KnownRequestInstrumentationEvents.IdentityRequest */, requestConfig, officeHomeApiRoot, correlationId)
        .then(function (response) {
        if (response &&
            response.data &&
            response.data.puid &&
            response.data.tenantId) {
            return response.data;
        }
        return Promise.reject({
            httpResponse: response,
            clientError: 'Invalid identity',
        });
    }, function (response) {
        return Promise.reject({
            httpResponse: response,
        });
    })
        .catch(function (error) {
        return Promise.reject(error);
    });
}
//# sourceMappingURL=getIdentity.js.map